// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","mapContainer":"App_mapContainer__DH78-","mainTitle":"App_mainTitle__ZQVGW","title":"App_title__YS7Xx"};